module.exports = __webpack_public_path__ + "static/media/starfighter-alt.17c300ff.svg";